import React from "react"
import { connect } from "react-redux"
import { Tabs } from "antd"
import "./MenuPopup.scss"

const { TabPane } = Tabs
const MenuPopup = (props) => {
  const { restaurantMenu } = props
  return (
    <Tabs defaultActiveKey="0" id="MenuPopup">
      {Object.keys(restaurantMenu).map((el, index) => (
        <TabPane tab={restaurantMenu[el].name} key={index}>
          {restaurantMenu[el].children.map((item, itemIndex) => (
            <div key={itemIndex} className="menu-item">
              <div className="menu-item-label">
                <div className="menu-item-name">
                  <strong>{item.name}</strong>
                </div>
                <div className="menu-item-price">$ {item.price}</div>
              </div>
            </div>
          ))}
        </TabPane>
      ))}
    </Tabs>
  )
}

const mapStateToProps = (state) => {
  return {
    restaurantMenu: state.planDinner.restaurantMenu,
  }
}

export default connect(mapStateToProps, null)(MenuPopup)
